/**
 * Computes where the cockpit cursor should move, given the ordered question
 * ids, the currently active id, and a direction.
 *
 * Returns the id to move to, or `null` to mean "no move":
 * - empty list → `null`
 * - nothing active → the first id (entering the queue)
 * - at a bound (last + next, or first + prev) → `null` (stay put)
 * - active id no longer in the list → recover to the first id on `next`,
 *   `null` on `prev`
 */
export function nextCursor(
  orderedIds: string[],
  activeId: string | null,
  direction: 'next' | 'prev',
): string | null {
  if (orderedIds.length === 0) return null;
  if (activeId === null) return orderedIds[0];

  const idx = orderedIds.indexOf(activeId);
  if (idx === -1) {
    return direction === 'next' ? orderedIds[0] : null;
  }

  const target = direction === 'next' ? idx + 1 : idx - 1;
  return orderedIds[target] ?? null;
}
